import { utils } from '@industriousapps/excelkits-core';
export const createWrappedError = utils.createWrappedError;